import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactImageFallback from 'react-image-fallback';
import { useQuery } from 'react-apollo';
import {
  staticConstants, capitalizeEveryWord, FALLBACK_ICON, getTimeAgoFormat, NUMERIC_VALUE,
} from '../../../../utils';
import { InviteArtistModal, ArtistDetail } from '../../../modals';
import { GET_OFFER_INVITED_LIST, GET_OFFER_RECOMMENDED_LIST, GET_OFFER_REQUEST_LIST } from '../../../../graphql-client/queries';

const queryObj = { page: NUMERIC_VALUE.ONE, limit: NUMERIC_VALUE.FIVE };

function OfferArtistList(props) {
  const {
    invitedArtist, viewType, requestModel, updateRequestStatus, basePrice, details,
    categories, publishAndInviteOffer, offerId, targetAudience,
  } = props;

  const [inviteArtistModal, setInviteArtistModal] = useState(false);
  const [artistDetailModal, setArtistDetailModal] = useState(false);
  const [artistDetailModalObj, setArtistDetailModalObj] = useState(null);
  const [defaultRecomendeds, setDefaultRecomendeds] = useState([]);
  const [defaultRequests, setDefaultRequests] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [recommendedCurrentPage, setRecommendedCurrentPage] = useState(1);

  const {
    loading, data: requestInfo, refetch: getOfferRequestRefetch,
  } = useQuery(
    GET_OFFER_REQUEST_LIST, {
      variables: { offerId, ...queryObj },
      fetchPolicy: 'network-only',
    },
  );

  const {
    loading: recommendedLoader, data: recommendedInfo, refetch: getRecommendedRefetch,
  } = useQuery(
    GET_OFFER_RECOMMENDED_LIST, {
      variables: { offerId, ...queryObj },
      fetchPolicy: 'network-only',
    },
  );

  const recommendedData = recommendedInfo?.recommendedUsernew;

  useEffect(() => {
    if (recommendedData && recommendedData.data && recommendedData.data.length > 0) {
      const { data } = recommendedData;
      setDefaultRecomendeds(recommendedCurrentPage === NUMERIC_VALUE.ONE ? data : defaultRecomendeds.concat(data));
    } else if (recommendedData && recommendedData.count !== 0 && recommendedData?.data.length === 0) {
      setDefaultRecomendeds([]);
    }
  }, [recommendedData]);

  const requestData = requestInfo?.requestedArtistList;

  useEffect(() => {
    if (requestData && requestData.data && requestData.data.length > 0) {
      const { data } = requestData;
      setDefaultRequests(currentPage === NUMERIC_VALUE.ONE ? data : defaultRequests.concat(data));
    } else if (requestData && requestData.count !== 0 && requestData.data.length === 0) {
      setDefaultRequests([]);
    }
  }, [requestData]);

  const toggleInviteArtistModal = () => {
    setInviteArtistModal(!inviteArtistModal);
  };

  const renderRequestList = () => {
    if (defaultRequests && defaultRequests.length) {
      return map(defaultRequests, (item) => {
        const {
          createdAt, userId: { artistImage, name }, email, managerId,
        } = item;
        const timeAgo = getTimeAgoFormat(createdAt);
        return item && (
        <div key={`${createdAt}`} className="request-row">
          <div className="image">
            <ReactImageFallback
              src={artistImage}
              fallbackImage={FALLBACK_ICON}
              className="image-cover"
              alt="artist"
            />
          </div>
          <div className="detail">
            <h4
              className="user-name"
              data-tip={email || (managerId && managerId.email)}
              data-place="bottom"
              data-background-color="#fff"
              data-text-color="#000"
            >
              {capitalizeEveryWord(name)}
            </h4>
            <ReactTooltip effect="solid" />
            <p>
              Applied
              {' '}
              {timeAgo}
            </p>
            <div className="request-btn-group">
              <span
                onClick={() => { requestModel(item); }}
                className="cursor-pointer"
              >
                Reject
              </span>
              <Button
                type="button"
                color="accept"
                onClick={() => { updateRequestStatus(staticConstants.STATUS_TYPE.ADMIN_ACCEPTED, item); }}
              >
                Accept
              </Button>
            </div>
          </div>
        </div>
        );
      });
    }
    if (defaultRecomendeds && !defaultRecomendeds.length && defaultRequests && !defaultRequests.length) {
      return (
        <div className="no-artist-section">
          <div className="no-artist-content">
            <div className="w-100 text-center">
              <Button
                onClick={() => { toggleInviteArtistModal(); }}
                color="send-request"
              >
                + Send request to Artist
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderRecomendedList = () => {
    if (defaultRecomendeds) {
      return map(defaultRecomendeds, (item) => {
        const {
          artistImage, name, isRequested, isRecomended, city, country, state, _id, email, managerId,
        } = item;
        const cityLabel = city && city.label;
        const stateLabel = state && state.label;
        const countryLabel = country && country.label;
        // return item && (isRecomended || isRequested) &&
        return item && (
        <div
          key={`${artistImage}`}
          className="request-row recommended"
        >
          <div
            className={`image ${!item.isInviteeArtist ? 'cursor-pointer' : ''}`}
            onClick={() => {
              !item.isInviteeArtist
              && setArtistDetailModal(true);
              setArtistDetailModalObj({ _id });
            }}
          >
            <ReactImageFallback
              src={artistImage}
              fallbackImage={FALLBACK_ICON}
              className="image-cover"
              alt="artist"
            />
          </div>
          <div className="detail modal-publish-list-row-name text-truncate">
            <h4
              className={`text-truncate ${item.isInviteeArtist ? 'mt-3' : ''} user-name`}
              data-tip={email || (managerId && managerId.email)}
              data-place="bottom"
              data-background-color="#fff"
              data-text-color="#000"
            >
              {!item.isInviteeArtist ? capitalizeEveryWord(name) : item.email }
              <ReactTooltip effect="solid" />
            </h4>
            <p className="text-truncate">
              {capitalizeEveryWord(cityLabel)}
              {cityLabel && ','}
              {' '}
              {capitalizeEveryWord(stateLabel)}
              {stateLabel && ','}
              {' '}
              {capitalizeEveryWord(countryLabel)}
            </p>
            <h3>
              { isRecomended
                && (
                  <em className="ml-0">Recommended</em>
                )}
            </h3>
            <span
              onClick={() => { !isRequested && toggleInviteArtistModal(); }}
              className={isRequested ? 'icon check' : 'icon plus'}
            />
          </div>
        </div>
        );
      });
    }
    return null;
  };

  return (
    <div className="offer-artist-wrapper">
      <Scrollbars
        style={{ height: '100%' }}
        thumbMinSize={30}
      >
        {/* {(viewType === staticConstants.STATUS_TYPE.PUBLIC || viewType === staticConstants.STATUS_TYPE.AFFILIATE) && ( */}
        <div className="artist-requests">
          {(defaultRequests && defaultRequests.length > 0)
          && <h2>Artist requests</h2>}
          {renderRequestList() }
          {(requestData?.hasNextData) && (
            <div className="request-row ">
              <div className="detail modal-publish-list-row-name text-truncate">
                <h4
                  className="user-name cursor-pointer"
                  data-place="bottom"
                  data-background-color="#fff"
                  data-text-color="#000"
                >
                  <u onClick={() => {
                    if (!loading) {
                      const page = currentPage + NUMERIC_VALUE.ONE;
                      setCurrentPage(page);
                      return getOfferRequestRefetch({ offerId, page, limit: NUMERIC_VALUE.FIVE });
                    }
                  }}
                  >
                    Load More

                  </u>
                </h4>
              </div>
            </div>
          )}
          {((defaultRequests && defaultRequests.length > 0) || (defaultRecomendeds && defaultRecomendeds.length > 0))
          && (
          <div className="w-100 text-center">
            <Button
              onClick={() => { toggleInviteArtistModal(); }}
              color="send-request"
            >
              + Send request to Artist
            </Button>
          </div>
          )}
          {renderRecomendedList()}
          {(recommendedData?.hasNextData) && (
            <div className="request-row recommended">
              <div className="detail modal-publish-list-row-name text-truncate">
                <h4
                  className="user-name cursor-pointer"
                  data-place="bottom"
                  data-background-color="#fff"
                  data-text-color="#000"
                >
                  <u onClick={() => {
                    if (!recommendedLoader) {
                      const page = recommendedCurrentPage + NUMERIC_VALUE.ONE;
                      setRecommendedCurrentPage(page);
                      return getRecommendedRefetch({ offerId, page, limit: NUMERIC_VALUE.FIVE });
                    }
                  }}
                  >
                    {' '}
                    Load More
                    {' '}

                  </u>
                </h4>
              </div>
            </div>
          )}
        </div>
        {/* )} */}
        {/* { viewType === staticConstants.STATUS_TYPE.PRIVATE && (
        <div className="recommended-artist">
          <div className="w-100 text-center">
            <Button
              onClick={() => { toggleInviteArtistModal(); }}
              color="send-request"
            >
              + Send request to Artist
            </Button>
          </div>
          {renderRecomendedList()}
        </div>
        )} */}
      </Scrollbars>
      { inviteArtistModal && (
      <InviteArtistModal
        isOpen={inviteArtistModal}
        onClose={() => { toggleInviteArtistModal(); }}
        publishAndInviteOffer={publishAndInviteOffer}
        categoriesData={categories}
        basePrice={basePrice}
        isInviteOnly
        offerId={offerId}
        targetAudience={targetAudience}
        isPrivateType={viewType === staticConstants.STATUS_TYPE.PRIVATE}
      />
      )}

      { artistDetailModal && artistDetailModalObj && (
      <ArtistDetail
        isOpen={artistDetailModal}
        onClose={() => {
          setArtistDetailModal(!artistDetailModal);
        }}
        userId={artistDetailModalObj._id}
        canEdit={false}
        key={Math.random()}
      />
      ) }
    </div>
  );
}

OfferArtistList.propTypes = {
  request: PropTypes.arrayOf(PropTypes.shape({
    createdAt: PropTypes.string,
    userId: PropTypes.shape({
      artistImage: PropTypes.string,
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  })),
  recomended: PropTypes.arrayOf(PropTypes.shape({
    isRequested: PropTypes.bool,
    userId: PropTypes.shape({
      artistImage: PropTypes.string,
      _id: PropTypes.string,
      name: PropTypes.string,
      email: PropTypes.string,
      managerId: PropTypes.shape({
        email: PropTypes.string,
      }),
    }),
  })),
  viewType: PropTypes.string,
  requestModel: PropTypes.func.isRequired,
  updateRequestStatus: PropTypes.func.isRequired,
  basePrice: PropTypes.number,
  targetAudience: PropTypes.object,
  categories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  publishAndInviteOffer: PropTypes.func.isRequired,
  invitedArtist: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string,
  })),
  offerId: PropTypes.string,
};

OfferArtistList.defaultProps = {
  request: null,
  recomended: null,
  invitedArtist: [],
  viewType: null,
  categories: null,
  basePrice: null,
  offerId: null,
  targetAudience: null,
};

export default OfferArtistList;
